import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { MenuStatus } from "Types/menu";

interface IState {
  status: MenuStatus;
}

const initialState: IState = { status: "disable" };

export const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    changeMenu: (state, action: PayloadAction<MenuStatus>) => {
      return { ...state, status: action.payload };
    },
  },
});

export const { changeMenu } = menuSlice.actions;

export default menuSlice.reducer;
